import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";


interface IErrorMessageProps {
    Message: string;
    ShowIcon: boolean;
    IconSize?: SizeProp;
}

const ErrorMessage = (props: IErrorMessageProps) => {
    return (
        <div className="center-block p-3 text-center">
          <Alert variant="danger" className="mb-0">
            {props.ShowIcon && (
              <Row>
                <Col xs={12}>
                  <FontAwesomeIcon icon={faTriangleExclamation} size={props.IconSize ?? "2x"} />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <span><b>{props.Message}</b></span>
              </Col>
            </Row>
          </Alert>
        </div>
    );
}

export default ErrorMessage;
